import React from 'react'

function StackBtn({data}) {
  return (
    <div className='py-1 px-3 shadow-2xl bg-text-light text-gray-900 rounded'>{data}</div>
  )
}

export default StackBtn